module.exports = __webpack_public_path__ + "img/sidebar_background.7c0d0b1a.png";